<template>
  <select class="form-control" v-model="selectedLang" @change="switchLocale($event)">
    <option :value="locale" v-for="locale in locales" :key="locale">{{ $t(mapLang(locale)) }}</option>
  </select>
</template>

<script>
export default {
  name: 'LocaleSwitcher',
  data() {
    return {
      selectedLang: this.$i18n.locale,
      locales: process.env.VUE_APP_I18N_LOCALE.split(',')
    }
  },
  methods: {
    switchLocale(locale) {
      const val = locale && locale.target && locale.target.value;
      if (this.$i18n.locale !== val) {
        this.$i18n.locale = val;
        this.selectedLang = val;
      }
    },

    mapLang(lang) {
      let data = "hi";
      switch (lang) {
        case "en":
          data = "lang.en";
          break;
        case "hi":
          data = "lang.hi";
          break;
        case "ma":
          data = "lang.ma";
          break;
        case "gu":
          data = "lang.gu";
          break;
        default:
          data = "lang.hi";
      }
      return data;
    }
  }
}
</script>
